export class IKeyValue<T1, T2> {
    key: T1;
    value: T2;
}
